export enum SideFilterKey {
  REGISTRATION_ORGANIZATION = "organization",
  APPROVALS = "approval",
  RATE_CARD = "rateCard",
  RPT = "participantType",
  REGISTRATION_FORM = "registrationForm",
  AGENDA_MEMBERS = "agendaMemberProfile",
  PROFILE = "profile",
  ENROLLMENT = "enrollment",
  WORKFLOW = "workflow",
  SELECTION_ROUND_1 = "selectionStatus",
  SELECTION_ROUND_2 = "selectionStatus",
  SELECTION_ROUND_3 = "selectionStatusOptIn",
  TABLETALK_INVITATION = "tabletalkInvitation",
  ACCEPT_MEETINGS = "acceptMeetings",
  ADDITIONAL_MEETINGS_MATCHING = "additionalMeetingsMatching",
  MEETING_INVITE_SENT = "meetingsInviteSent",
  MEETINGS_RECONCILIATION = "meetingsReconciliation",
  TABLETALK_MEETINGS_INITIAL_MEETING_MATCHING = "tabletalkMeetingsInitialMeetingMatching",
  TABLETALK_MEETINGS_FINAL_MEETING_MATCHING = "tabletalkMeetingsFinalMeetingMatching",
  TABLETALK_MEETINGS = "tabletalkMeetings",
  PROGRAM_FEEDBACK = "programFeedback",
  REIMBURSEMENT = "programParticipantReimbursement",
  ORGANIZATION_PROFILE = "organizationProfile",
  ACTIVITY_SHORTLIST = "activityShortlist",
  ACTIVITY_AGENDA_SCHEDULE = "activityAgendaSchedule",
  ACTIVITY_AGENDA_IN_PROGRESS = "activityInProgress",
  ACTIVITY_PROFILE = "activity"
}
